import * as React from 'react';

import './GoToCart.scss';
import { I18nextProviderProps } from 'react-i18next';
import { ifLoggedIn, goToCart, cartUrl } from 'src/utils/navigation';
import cartIcon from 'src/assets/cartIcon';
import i18n from 'src/translation/i18n';

interface IGoToCartProps extends I18nextProviderProps {
  itemsInCart?: number;
  t?: any;
  isMobile?: boolean;
  getItemCount: () => void;
  isLoggedIn: boolean;
}

interface IMyOrdersMenuState {
  floatingIsOpen: boolean;
}

export default class GoToCart extends React.Component<
  IGoToCartProps,
  IMyOrdersMenuState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      floatingIsOpen: true
    };
  }

  public componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.getItemCount();
    }
  }

  private goToCart = () => ifLoggedIn(() => goToCart());

  private renderDesktop() {
    const { t } = this.props;

    const active = this.isCartEmpty() ? '' : 'active';

    return (
      <div id="go-to-cart" onClick={this.goToCart}>
        <div className={`counter-column ${active}`}>
          <div className="go-to-cart--counter">
            {this.props.itemsInCart || '0'}
          </div>
          <a href={cartUrl()} className="icon">
            {/* <i className="rpds-shopping-cart go-to-cart--avatar" /> */}
            <img src={cartIcon} alt="Go to Cart" className="cart-icon" />
          </a>
          <a href={cartUrl()} className="subheader">
            {i18n.t('menu.cart')}
          </a>
        </div>
        {/* <div className="item-description">
          <a href={cartUrl()} className="subheader">
            {t('menu.goTo')}
          </a>
          <a href={cartUrl()} className="header">
            {t('common.cart')}
          </a>
        </div> */}
      </div>
    );
  }

  private renderMobile() {
    const active = this.isCartEmpty() ? '' : 'active';
    return (
      <div className={`counter-column ${active}`}>
        <div className="go-to-cart--counter">
          {this.props.itemsInCart || '0'}
        </div>
        <div id="go-to-cart-mobile" onClick={this.goToCart}>
          {/* <i className="rpds-shopping-cart go-to-cart--avatar" /> */}
          <img src={cartIcon} alt="Go to Cart" className="cart-icon" />
        </div>
      </div>
    );
  }

  public render() {
    return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
  }

  private isCartEmpty = () => {
    const { itemsInCart } = this.props;
    return +itemsInCart === 0 || !itemsInCart;
  };
}
